<template>
	<div class="filelibrary">
		<topcon :maxtitle="'文件'" :mintitle="'库'" :sign="'3'"></topcon>
		
		<div class="alllist">
			<div class="signle wrap" v-for="(item,index) in list" :key="index" @click="todetail(item)">
				<!-- <div class="bit"></div> -->
				<div class="title overfh" :title="item.title">{{item.title}}</div>
				<div class="date">{{item.createTime.split(' ')[0] || ''}}</div>
			</div>
		</div>
		
	</div>
	
</template>

<script>

import topcon from "../com/topcon.vue";
export default {
  components: {
   	 topcon,
  },
  
  data: function() {
    return {
		list:[],
	  
    };
  },
  
  mounted() {
		this.getCulturallist()
  },
  
  methods: {
		getCulturallist(){
			  this.$get(`web/culturalproduct/datalist?pageSize=8&pageNo=1&dataType=0`).then(res=>{
				  if(res.success){
					  this.list = res.result.records;
				  }
			  })
		},
		
		todetail(item){
			this.$router.push({ path: '/textdetail?id='+item.id +'&type=1'});			
		},
		
  },
  
  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.filelibrary{

	.alllist{
		margin-top: 30px;
		.signle{
			display: flex;
			align-items: center;
			height: 40px;
			cursor: pointer;
			.title{
				flex: 1;
				font-size: 18px;
				font-weight: 400;
				color: #000000;
				margin-left: 10px;
				width: calc(100% - 130px);
			}
			.date{
				width: 120px;
				text-align: right;
				font-size: 18px;
				font-weight: 400;
				color: #666666;
			}
		}
		
		.signle:hover .title{
			color: #E61F26;
		}
		.signle:hover .date{
			color: #E61F26;
		}
		
	}
	
	
	
	
	
}

</style>
